import { useSnackbar } from "notistack";
import Slide from "@mui/material/Slide";
import { Button } from "@mui/material";
import { useCallback } from "react";

export const useErrorMessage = () => {
  const { enqueueSnackbar, closeSnackbar: closeError } = useSnackbar();

  const [vertical, horizontal] = ["bottom", "right"];

  function TransitionLeft(props) {
    return <Slide {...props} direction="left" />;
  }

  const action = useCallback(
    (snackbarId) => (
      <Button
        onClick={() => {
          closeError(snackbarId);
        }}
        variant="outlined"
        size="small"
        sx={{
          color: "#fff",
          backgroundColor: "transparent",
          borderColor: "white",
          "&:hover": {
            backgroundColor: "#fff",
            color: "rgb(195, 63, 56)",
            borderColor: "white",
          },
        }}
      >
        Dismiss
      </Button>
    ),
    [closeError]
  );

  const setError = useCallback(
    (message) => {
      enqueueSnackbar(message.toString(), {
        autoHideDuration: 6000,
        anchorOrigin: { vertical, horizontal },
        TransitionComponent: TransitionLeft,
        variant: "error",
        action,
      });
    },
    [enqueueSnackbar, vertical, horizontal, action]
  );

  return { setError, closeError };
};
